import { rescueModalUiButtonSubtextSchema } from "@redotech/redo-model/checkouts/predictive-conversion-settings";
import { SlideInPanelAnchorLocation } from "@redotech/redo-model/slide-in-panel/slide-in-panel-anchor-location";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getCheckoutProbabilityRescueModalSettings = {
  name: "getCheckoutProbabilityRescueModalSettings" as const,
  input: z.null(),
  output: z.object({
    rescueModalEnabled: z.boolean(),
    rescueModalDiscountCode: z.string().optional(),
    rescueModalDiscountPercent: z.string().optional(),
    rescueModalDiscountAutoGenerateRandomCode: z.boolean().optional(),
    rescueModalDiscountTitle: z.string().optional(),
    rescueModalDiscountCombinesWithOrderDiscounts: z.boolean().optional(),
    rescueModalDiscountCombinesWithProductDiscounts: z.boolean().optional(),
    rescueModalDiscountCombinesWithShippingDiscounts: z.boolean().optional(),
    rescueModalUiTitle: z.string().optional(),
    rescueModalUiDescription: z.string().optional(),
    rescueModalUiButtonText: z.string().optional(),
    rescueModalUiButtonSubtext: rescueModalUiButtonSubtextSchema.optional(),
    rescueModalUiPlacement: createEnum(SlideInPanelAnchorLocation, {
      enumName: "SlideInPanelAnchorLocation",
    }).optional(),
  }),
};
